// extracted by mini-css-extract-plugin
export default {"search":"SearchBar_search__oWUMW","search-form":"SearchBar_search-form__k9bqE","search-input":"SearchBar_search-input__+M7T2","expand":"SearchBar_expand__B6Nm9"};